import useAuthSuccessCallback from './auth/useAuthSuccessCallback'
import { useReduxDispatch, useReduxSelector } from 'store'
import React, { useEffect, useRef, useState } from 'react'
import { selectRest, showPopup } from 'rest/restSlice'
import useTranslation from 'hooks/useTranslation'
import HeadersManager from 'rest/HeadersManager'
import { APP_AUTH_KEY } from 'rest/AuthEvent'
import * as nativeApp from 'utils/nativeApp'
import Popup from 'components/popups/Popup'
import { parseJwt } from 'utils/parseJwt'
import PinPopup from './auth/PinPopup'

const isNativeApp = nativeApp.checkIsNativeApp()
const NativeAuth: React.FC = () => {
  const [isForm, showForm] = useState(false)
  const { isPopup, popupBody } = useReduxSelector(selectRest)
  const { nativeKey = '', type } = popupBody as rest.UnauthorizedResponse

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('auth')
  const successCallback = useAuthSuccessCallback(true)

  const currentActions = useRef({ dispatch, successCallback })
  currentActions.current.dispatch = dispatch
  currentActions.current.successCallback = successCallback

  /**
   * Deprecated
   */
  useEffect(() => {
    const authListener = () => {
      dispatch(showPopup())
    }
    document.addEventListener(APP_AUTH_KEY, authListener)
    return () => {
      document.removeEventListener(APP_AUTH_KEY, authListener)
    }
  }, [dispatch])

  useEffect(() => {
    const authListener = (e: Event) => {
      const token = (e as CustomEvent<{ token?: string }>)?.detail?.token
      console.log('biometricAuthResponse token: ', token)
      if (token) {
        currentActions.current.dispatch(showPopup())
        currentActions.current.successCallback({ success: true, token, type: 'biometric' })
      } else {
        showForm(true)
      }
    }

    window.addEventListener('biometricAuthResponse', authListener)
    return () => {
      window.removeEventListener('biometricAuthResponse', authListener)
    }
  }, [])

  useEffect(() => {
    if (type && isNativeApp) {
      nativeApp.authorize(getAuthData(nativeKey))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isForm) {
    return (
      <Popup isPopup={isPopup}>
        <PinPopup
          additionalButton={<div
            className='popup__additionalBtn center'
            onClick={() => {
              nativeApp.authorize(getAuthData(nativeKey))
            }}>
            {nativeApp.checkIsIos()
              ? <>
                <p>{t('retryFaceId')}</p>
                <i className='icon icon--faceId s32' />
              </> : <>
                <p>{t('retryBiometric')}</p>
                <i className='icon icon--fingerprint s32' />
              </>}
          </div>}
        />
      </Popup>
    )
  }

  return null
}

const getAuthData = (nativeKey: string, error = false) => {
  const jwt = HeadersManager.jwt.get()
  const { enc } = parseJwt(jwt)
  const data = {
    nativeKey,
    key: enc,
    error
  }

  return JSON.stringify(data)
}

export default NativeAuth